
export const VISIBLE_BUTTONS = { insert: false, edit: false, delete: false }
export const PROPERTY_LIQUID_DICTIONARY = [
  {
    options: "facility",
    save: { store: false, self: true },
    load: "self",
    keyName: "facility_name",
    valueName: "facility_name",
  },
  {
    options: "flange",
    save: { store: false, self: true },
    load: "self",
    keyName: "flange_no",
    valueName: "flange_no",
  },
];
export const PROPERTY_LIQUID_COLUMNS = [
  {
    header: "Объект",
    field: "facility_name",
    sortable: true,
    filterData: {
      options: "facility",
      type: "MultiSelect",
      attrList: { filter: true },
      mode: "in",
      valueName: "facility_name",
    },
  },
  {
    header: "Фл(ус)",
    field: "flange_no",
    bodyStyle: "text-align: center;",
    sortable: true,
    filterData: {
      options: "flange",
      type: "Dropdown",
      mode: "equals",
      valueName: "flange_no",
    },
  },
  {
    header: "Дата",
    field: "property_log_date",
    sortable: true,
    dataType: "date-gmt",
    //conversion: true,
    headerStyle: "width: 140px",
    filterData: {
      type: "Calendar",
      mode: "dateIsGMT",
      attrList: { dateFormat: "dd.mm.yy" },
    },
  },
  {
    header: "Время, ч:м:cек",
    field: "property_log_date_time",
    sortable: true,
    dataType: "time-gmt",
    conversion: true,
    headerStyle: "width: 140px",
  },
  {
    header: "Дебит",
    field: "q_liq",
    bodyStyle: "text-align: right;",
    sortable: true,
    columnType: 'numeric',
    showFilterMenu: true,
    filterData: {
      type: "InputNumber",
      "max-width": "100px",
      attrList: { mode: "decimal", step: 0.01, showButtons: true },
    },
    summary: {
      header: "Ср",
      type: "avg",
    },
  },
  {
    header: "Кол-во за период",
    field: "liquid_outvalue",
    bodyStyle: "text-align: right;",
    sortable: true,
    columnType: 'numeric',
    showFilterMenu: true,
    filterData: {
      type: "InputNumber",
      "max-width": "90px",
      attrList: { mode: "decimal", step: 0.01, showButtons: true },
    },
    summary: {
      header: "Сум",
      type: "sum",
    },
  },
  {
    header: "Накопление чч:мин",
    field: "property_accum_duration_hh_min",
    sortable: true,
  },
  {
    header: "Рассчитанное значение",
    field: "property_outvalue",
    bodyStyle: "text-align: right;",
    sortable: true,
    columnType: 'numeric',
    showFilterMenu: true,
    filterData: {
      type: "InputNumber",
      "max-width": "90px",
      attrList: { mode: "decimal", step: 0.1, showButtons: true },
    },
  },
  {
    header: "Значение",
    field: "property_value",
    bodyStyle: "text-align: right;",
    sortable: true,
    visible: false,
  },
];
export const PROPERTY_LIQUID_CROSS_DAY_COLUMNS = [
  {
    header: "День",
    field: "property_log_day",
    sortable: true,
  },
];
export const getPropertyLiquidHourlyColumns = (routeParams) => {
  const isGMS = (routeParams?.facility_type_id == 6005);
  return [
    {
      header: "Часы",
      field: "hour",
      summary: {
        header: isGMS ? "Среднее " : "Сумма ",
      },
    },
  ]
}
export const PROPERTY_LOG_DICTIONARY = [
  {
    options: "property_type",
    save: { store: false, self: true },
    load: "self",
    keyName: "property_type_name",
    valueName: "property_type_name",
  },
];
export const PROPERTY_LOG_COLUMNS = [
  {
    header: "Объект",
    field: "facility_name",
    sortable: true,
  },
  {
    header: "Фл(Ус)",
    field: "flange_no",
    sortable: true,
    bodyStyle: "text-align: center;",
    filterData: {
      type: "InputText",
      "max-width": "60px",
      attrList: { type: "number", step: "1" },
    },
  },
  {
    header: "Свойство",
    field: "property_type_name",
    sortable: true,
    filterData: {
      options: "property_type",
      type: "MultiSelect",
      mode: "in",
      valueName: "property_type_name",
    },
  },
  {
    header: "Описание",
    field: "property_desc",
    sortable: true,
  },
  {
    header: "Дата",
    field: "property_log_date_of",
    dataType: "date-gmt",
    conversion: true,
    sortable: true,
  },
  {
    header: "Время",
    field: "property_log_date",
    dataType: "time-gmt",
    conversion: true,
    sortable: true,
  },
  {
    header: "Значение",
    field: "property_value",
    sortable: true,
    bodyStyle: "text-align: right;",
    columnType: 'numeric',
    showFilterMenu: true,
    filterData: {
      type: "InputNumber",
      "max-width": "80px",
      attrList: { mode: "decimal", step: 0.1, showButtons: true },
    },
  },
  {
    header: "Рассчетное значение",
    field: "property_outvalue",
    sortable: true,
    bodyStyle: "text-align: right;",
    columnType: 'numeric',
    showFilterMenu: true,
    filterData: {
      type: "InputNumber",
      "max-width": "80px",
      attrList: { mode: "decimal", step: 0.1, showButtons: true },
    },
  },
  {
    header: "Интерпретация",
    field: "property_outvalue_text",
    sortable: true,
  },
  {
    header: "Накопленное значение",
    field: "property_accum_value",
    sortable: true,
    bodyStyle: "text-align: right;",
    columnType: 'numeric',
    showFilterMenu: true,
    filterData: {
      type: "InputNumber",
      "max-width": "100px",
      attrList: { mode: "decimal", step: 0.01, showButtons: true },
    },
  },
  {
    header: "Период накопления (мин)",
    field: "property_accum_duration_minute",
    sortable: true,
    bodyStyle: "text-align: right;",
    columnType: 'numeric',
    showFilterMenu: true,
    filterData: {
      type: "InputNumber",
      "max-width": "100px",
      attrList: { mode: "decimal", step: 0.01, showButtons: true },
    },
  },
];
export const TIMES = [
  "02:00",
  "04:00",
  "06:00",
  "08:00",
  "10:00",
  "12:00",
  "14:00",
  "16:00",
  "18:00",
  "20:00",
  "22:00",
  "24:00"
];
export const getToolbarFiltersDate = (routeParams) => {
  return [
    {
      name: "facility",
      enabled: true,
      required: false,
      default: Number(routeParams.facility_id),
      attrList: { disabled: true },
    },
    {
      name: "periods",
      enabled: true,
      required: true,
      default: "Выбранная дата",
      params: ["date_begin", "date_end"],
      attrList: { date_begin: { selectOtherMonths: true }, date_end: { selectOtherMonths: true } }
    },
    {
      name: "lookup",
      caption: "Тип свойства",
      params: ["property_velocity"],
      default: 1,
      enabled: true,
      required: true,
      style: { width: "9rem" },
      attrList: {
        options: [
          { name: "Стандартные", id: 1 },
          { name: "Быстрые", id: 2 },
          { name: "Все", id: 3 },
        ],
        optionLabel: "name",
        optionValue: "id",
      },
    },
  ];
};
export const getToolbarFiltersHourly = (routeParams) => {
  return [
    {
      name: "facility",
      enabled: true,
      required: false,
      default: Number(routeParams.facility_id),
      attrList: { disabled: true },
    },
    {
      name: "periods",
      enabled: true,
      required: true,
      default: "Выбранная дата",
      params: ["date", "date_end"],
      attrList: { period_name: { disabled: true }, date_begin: { selectOtherMonths: true } },
    },
  ];
};
export const getToolbarFiltersYearmonth = (routeParams) => {
  return [
    {
      name: "facility",
      enabled: true,
      required: false,
      default: Number(routeParams.facility_id),
      attrList: { disabled: true },
    },
    {
      name: "yearmonth",
      enabled: true,
      required: true,
    },
  ];
};
export const getToolbarFiltersCrossYearmonth = (routeParams) => {
  return [
    {
      name: "facility",
      enabled: true,
      required: false,
      default: Number(routeParams.facility_id),
      attrList: { disabled: true },
    },
    {
      name: "yearmonth",
      enabled: true,
      required: true,
    },
    {
      name: "lookup",
      caption: "Значения",
      params: ["liq_values_agg"],
      default: 0,
      enabled: true,
      required: true,
      style: { width: "14rem" },
      attrList: {
        options: [
          { name: "Добыча за сутки", id: 0 },
          { name: "Последние за сутки", id: 1 },
          { name: "Средние за сутки", id: 2 },
        ],
        optionLabel: "name",
        optionValue: "id",
      },
    },
  ];
};
